/**
 * @generated SignedSource<<a0d8070408586d98625482ec55589f5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ForgotPasswordScreenResetPasswordMutation$variables = {
  email: string;
};
export type ForgotPasswordScreenResetPasswordMutation$data = {
  readonly resetPassword: boolean | null | undefined;
};
export type ForgotPasswordScreenResetPasswordMutation = {
  response: ForgotPasswordScreenResetPasswordMutation$data;
  variables: ForgotPasswordScreenResetPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ScalarField",
    "name": "resetPassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordScreenResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgotPasswordScreenResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78346fef3c29924b9993d0f08e47dde7",
    "id": null,
    "metadata": {},
    "name": "ForgotPasswordScreenResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ForgotPasswordScreenResetPasswordMutation(\n  $email: String!\n) {\n  resetPassword(email: $email)\n}\n"
  }
};
})();

(node as any).hash = "82157b14c74b0b830d243a2711755ea2";

export default node;
